//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
import { memo, useMemo } from "react";
import { Container } from "react-bootstrap";
import FiiMfTable from "./FiiMfTable";
import DiiTable from "./DiiTable";
import MfTable from "./MfTable";

const HoldingsTable = ({ trayExpanded, strSeletedCategory, objselectedScreener, FIIArray, DIIArray, MFArray, ...props }) => {
    const TableContents = useMemo(() => {
        if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Foreign Institution') {
            return <FiiMfTable trayExpanded={trayExpanded} fiData={FIIArray} />;
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Domestic Institution') {
            return <DiiTable trayExpanded={trayExpanded} diiData={DIIArray} />;
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Mutual Funds') {
            return <MfTable trayExpanded={trayExpanded} mfData={MFArray} />;
        } else {
            return null;
        }

    }, [strSeletedCategory, objselectedScreener, FIIArray, DIIArray, MFArray,trayExpanded]);

    return (
        <Container fluid className='p-0'>
            {TableContents}
        </Container>
    );
};

export default memo(HoldingsTable);
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End